module.exports = __webpack_public_path__ + "static/media/speaker_guanshengChen.a4f4a6c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speaker_guanshengChen.jpg
// module id = 241
// module chunks = 0